import { render, staticRenderFns } from "./CourseGroupDetailCard.vue?vue&type=template&id=2526868d&scoped=true&"
import script from "./CourseGroupDetailCard.vue?vue&type=script&lang=js&"
export * from "./CourseGroupDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./CourseGroupDetailCard.vue?vue&type=style&index=0&id=2526868d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2526868d",
  null
  
)

export default component.exports